import type { MapStyleOption } from '../components/ui/map';

export function getMapStyles(maptilerKey: string): { light: MapStyleOption; dark: MapStyleOption } {
  return {
    light: `https://api.maptiler.com/maps/streets-v2/style.json?key=${maptilerKey}`,
    // Dataviz dark has preferred interaction feel; we inject 3D buildings separately.
    dark: `https://api.maptiler.com/maps/dataviz-dark/style.json?key=${maptilerKey}`,
  };
}
